import qs from 'qs'
import request from '@/utils/request'

function toFormData (data = {}) {
  const params = {}
  Object.keys(data).forEach(key => {
    const value = data[key]
    if (value !== undefined && value !== null && value !== '') {
      params[key] = Array.isArray(value) || typeof value === 'object' ? JSON.stringify(value) : value
    }
  })
  return qs.stringify(params)
}

// 报告包列表
export function getRtReportModelList (data) {
  return request({
    url: '/rtReportModel/getRtReportModelList',
    method: 'post',
    data: toFormData(data)
  })
}

// 联动查询参数
export function getRtReportModelListParam (data) {
  return request({
    url: '/rtReportModel/getRtReportModelListParam',
    method: 'post',
    data: toFormData(data)
  })
}

// 报告包详情
export function getRtReportModelDetails (data) {
  return request({
    url: '/rtReportModel/getRtReportModelDetails',
    method: 'post',
    data: toFormData(data)
  })
}

// 新增报告包（文件流提交，file 字段携带文件）
export function addRtReportModel (formData) {
  return request({
    url: '/rtReportModel/addRtReportModel',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 编辑报告包（文件流提交，file 字段携带文件）
export function updateRtReportModel (formData) {
  return request({
    url: '/rtReportModel/updateRtReportModel',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 删除报告包
export function deleteRtReportModel (data) {
  return request({
    url: '/rtReportModel/deleteRtReportModel',
    method: 'post',
    data: toFormData(data)
  })
}

// 上传文件到服务器本地-模板库（查看弹窗-资料地址编辑）
export function uploadFileLocalReportModel (formData) {
  return request({
    url: '/rtReportModel/uploadFileLocalReportModel',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 分页响应标准化
export function normalizePageResponse (res) {
  return {
    list: Array.isArray(res && res.data) ? res.data : [],
    total: Number((res && res.total) || 0),
    raw: res
  }
}
